import React, { useEffect, useState } from 'react';
import UserLinkService from '../../Services/UserLinkService';
import UserLinkSearchParams from '../../Elements/UserLinkSearchParams';
import ShownOverWindowsEnum from '../../Enums/ShownOverWindowsEnum';
import UserLinkListComponent from '../Operations/Projects/UserLinkListComponent';
import CookieHelper from '../../Helpers/cookieHelper';
import { linkVariant } from './homeHelpers';

function PersonalLinks() {
  const [userLinks, setUserLinks] = useState([]);
  const [open, setOpen] = useState(
    () => CookieHelper.getCookie(CookieHelper.CookieNameEnum.PersonalLinksCollapsed, 'true') === 'false'
  );
  const [shownOverWindow, setShownOverWindow] = useState(ShownOverWindowsEnum.None);

  const load = () => {
    const searchItem = new UserLinkSearchParams();
    searchItem.OnlyHomePageLinks = true;
    const maxInt = 2147483647;
    UserLinkService.GetUserLinks('Order', 'Asc', 1, maxInt, searchItem)
      .then((result) => setUserLinks(UserLinkService.ConvertDBItemList(result.data)))
      .catch(() => setUserLinks([]));
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    CookieHelper.setCookie(CookieHelper.CookieNameEnum.PersonalLinksCollapsed, !next);
  };

  return (
    <div className="plinks">
      {shownOverWindow === ShownOverWindowsEnum.LinkList ? (
        <UserLinkListComponent
          clickOnCancel={() => setShownOverWindow(ShownOverWindowsEnum.None)}
          handleListItemOnChange={() => load()}
        />
      ) : null}

      <div className="plinks-head-row" style={{ display: 'flex', alignItems: 'center' }}>
        <button className={'plinks-head' + (open ? ' open' : '')} onClick={toggle} aria-expanded={open}>
          <span className="pl-chev"><i className="fa-solid fa-chevron-down" /></span>
          <span className="pl-ic"><i className="fa-solid fa-link" /></span>
          <span className="pl-title">Personal links</span>
          <span className="pl-count">{userLinks.length}</span>
        </button>
        <div className="sp" style={{ flex: 1 }} />
        <button
          className="plinks-gear"
          style={{ marginRight: 12 }}
          title="Manage links"
          aria-label="Manage personal links"
          onClick={() => setShownOverWindow(ShownOverWindowsEnum.LinkList)}
        >
          <i className="fa-solid fa-gear" />
        </button>
      </div>

      {open ? (
        <div className="plinks-body">
          {userLinks.length ? (
            <div className="plink-wrap">
              {userLinks.map((l) => {
                const variant = linkVariant(l.BackColor);
                return (
                  <a
                    key={l.UserlinkId}
                    className={'plink' + (variant ? ' ' + variant : '')}
                    href={l.Url}
                    target={l.Target}
                    rel="noopener noreferrer"
                    title={l.Text}
                  >
                    {l.Title}
                    {l.Target === '_blank' ? (
                      <span className="pk-ext"><i className="fa-solid fa-arrow-up-right-from-square" /></span>
                    ) : null}
                  </a>
                );
              })}
            </div>
          ) : (
            <div className="plinks-empty">
              <i className="fa-solid fa-link" /> No personal links yet.
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default PersonalLinks;
